module.exports = __webpack_public_path__ + "static/da1000x500-ad6aba91d294634514056c3ddd6c3643.png";